import actions from './actions-order.js'
import mutations from './mutations-order.js'
import getters from './getters-order.js'
import state from './state-order.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}